import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import PropTypes from "prop-types";
import {UseCaseList} from "../Components/Contents/UseCaseList";
import ErrorPages from "../Components/EssentialPages/ErrorPages/ErrorPages";
import MetaData from "../Components/MetaData/MetaData";
import Button from "../Components/BasicComponents/Button";
import Linkify from "linkify-react";
import registerKeywords from "linkify-plugin-keyword";
import {DefaultParameters} from "../Api/ApiCallMethod";
import {Link} from "react-router-dom";
import RequestAccess from "./RequestAccess";

const SignupRoute = DefaultParameters().ProductURL + DefaultParameters().SignupRoute

registerKeywords([
    "Sign Up",
    "Try IP Agent AI today",
    "Free Trial",
    "Sign Up Today",
    "Start Free Trial of IP Agent for AI Today"
]);

const keywordMap = {
    "Sign Up": SignupRoute,
    "Try IP Agent AI today": SignupRoute,
    "Free Trial": SignupRoute,
    "Sign Up Today": SignupRoute,
    "Start Free Trial of IP Agent for AI Today": SignupRoute,
};

const options = {
    formatHref: {
        // keyword: (word) => keywordMap[word] || "#"
        keyword: (word) => keywordMap[word] || SignupRoute
    },
    attributes: {
        target: "_blank",
        rel: "noopener noreferrer"
    }
};

export default class UseCaseDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            translationReasonList: [
                {
                    Title: "International Patent Filings",
                    Description: [
                        "When filing patents in multiple countries, translations are required to comply with the official languages of those jurisdictions."
                    ]
                },
                {
                    Title: "Legal Enforcement",
                    Description: [
                        "Accurate translations ensure that the patent’s scope and claims are upheld during litigation or examination in foreign jurisdictions."
                    ]
                },
                {
                    Title: "Collaboration",
                    Description: [
                        "Translations help inventors, attorneys, and examiners collaborate across different linguistic and cultural boundaries."
                    ]
                },
            ],
            translationFAQ: [
                {
                    Question: "How are the translations done by IP Agent AI?",
                    Answer: [
                        "The translations are done using google translate and privately hosted llms."
                    ]
                },
                {
                    Question: "Are the translations comprehensive?",
                    Answer: [
                        "NO. The translations must be used as first cut and validated with professional translators. IP Agent AI bears no responsibility for the accuracy of the translations."
                    ]
                },
                {
                    Question: "Why do I need to use the free translation provided by IP Agent AI when I need a professional translator?",
                    Answer: [
                        "IP Agent AI does majority of the translation work and the professional translators do the validation and refining the translation there by time and money for the customers. Professional translators can focus on the more intriguing and fun part of translations and avoid mundane work."
                    ]
                },
            ]
        }
    }

    getUseCaseQuote = (info) => {
        return (
            <div className="use-case-quote-division">
                <div className="use-case-quote-bar"/>
                <div className="use-case-quote-info">
                    {
                        info.Quote.map((quoteInfo, qid) =>
                            <p>{quoteInfo}</p>
                        )
                    }
                </div>
            </div>
        )
    }
    onSignUp = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().SignupRoute
        window.open(productUrl, '_blank');
    }

    scrollToTop = () => {

        if (this.scrollRef.current) {
            this.scrollRef.current.scrollTo({
                top: 0,
                behavior: 'instant',

            });
        }


    }

    render() {
        let {useCaseID} = this.props;
        let info = UseCaseList[useCaseID];
        return (
            info !== undefined && info !== null ?
                <>
                    <div className="use-case-detail-layout">
                        <MetaData keyword={"ai-ip-use-cases"}/>
                        <div className="use-case-detail-layout-header"/>
                        <div className="use-case-detail-layout-body">
                            <div className="use-case-detail-form">
                                <div className="use-case-detail-header">
                                    <div className="use-case-detail-header--left">
                                        <h1>{info.Header}</h1>
                                        {
                                            info.SubTitle !== undefined && info.SubTitle !== null && info.SubTitle !== "" ?
                                                <div className="use-case-detail-tag">
                                                    - {info.SubTitle} -
                                                </div>
                                                :
                                                null

                                        }

                                        {
                                            info.Available &&
                                            <Button type={"primary"} className="use-case-detail-action-btn">Sign
                                                Up</Button>
                                        }

                                    </div>
                                    <div className="use-case-detail-header--right">
                                        <img src={info.Illustration} alt={info.IllustrationDescription}/>
                                    </div>
                                </div>
                                <div className="use-case-detail-body">
                                    {/*{this.getUseCaseQuote(info)}*/}
                                    <div className="use-case-section-division">
                                        <Linkify options={options}>
                                            {
                                                info.Context.map((sectionInfo, sid) =>
                                                    <div className="use-case-section" key={sid}>
                                                        {
                                                            sectionInfo.Title !== undefined && sectionInfo.Title !== null && sectionInfo.Title !== "" &&
                                                            <h3 className={sectionInfo.Essential ? "use-case-section-title highlighted" : "use-case-section-title"}>
                                                                {sectionInfo.Title}
                                                            </h3>
                                                        }

                                                        <div className="use-case-section-body">
                                                            {
                                                                sectionInfo.Body.map((info, id) =>
                                                                    info.Tag === "p" ?
                                                                        <p key={id}>{info.Paragraph}</p>
                                                                        :
                                                                        info.Tag === "img" ?
                                                                            // <div className="use-case-ss-division">
                                                                            //     {
                                                                            //         info.ImageInfo.map((ss,ssid)=>
                                                                            //             <div className="use-case-ss" key={ssid}>
                                                                            //                 <img src={ss.Image} alt={ss.Name}/>
                                                                            //             </div>
                                                                            //         )
                                                                            //     }
                                                                            //
                                                                            // </div>
                                                                            null
                                                                            :
                                                                            info.Tag === "button" ?
                                                                                null
                                                                                :

                                                                                info.Tag === "ol" ?
                                                                                    <ol>
                                                                                        {
                                                                                            info.ListInfo.map((listItem, lid) =>
                                                                                                <li key={lid}>
                                                                                                    <div
                                                                                                        className="use-case-section-list-item">
                                                                                                        <div
                                                                                                            className="use-case-section-list-item-title">
                                                                                                            {listItem.ItemTitle}
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="use-case-section-list-item-description-division">
                                                                                                            {
                                                                                                                listItem.ItemBody !== undefined && listItem.ItemBody !== null && listItem.ItemBody.length !== 0 ?
                                                                                                                    listItem.ItemBody.map((info) =>
                                                                                                                        <div
                                                                                                                            className="use-case-section-list-item-description">
                                                                                                                            {info}
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                    :
                                                                                                                    null
                                                                                                            }

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </li>
                                                                                            )
                                                                                        }

                                                                                    </ol>
                                                                                    :

                                                                                    info.Tag === "diagram" ?
                                                                                        info.Diagram
                                                                                        :


                                                                                        info.Text
                                                                )
                                                            }


                                                        </div>
                                                    </div>
                                                )
                                            }

                                        </Linkify>
                                        {
                                            info.Available &&
                                            <Button type={"primary"} className="use-case-detail-btn">
                                                Free Trial
                                            </Button>
                                        }

                                        <Link to={`/ai-ip-use-cases`} onClick={() => this.props.resetInfo()}>
                                            {"<-"} Back To Use Case List
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        !info.Available &&
                        <RequestAccess page={"detail"}/>
                    }
                </>
                :
                <ErrorPages/>
        );
    }

}
UseCaseDetail.propTypes = {
    useCaseID: PropTypes.object.isRequired
}